import type { ReactNode } from "react";
import { Flex } from "@/components/Flex/Flex";
import { Text } from "@/components/Text";

/** The page's headline, and the celebratory disc above it.
 *
 *  With an `event` card the disc is dropped and the block goes left-aligned: the
 *  disc costs ~100px of a 780px fold, and the эфир date has to win that space.
 *  The page still says «Вы записаны» — it just does not spend a sixth of the
 *  first screen saying it twice. */
export function PageHeading({
  mode,
  title,
  subtitle,
  hasEvent,
}: {
  mode: string;
  title: string;
  subtitle?: ReactNode;
  hasEvent: boolean;
}) {
  return (
    // Left-aligned with an event card — and then it must share the `max-w-xl`
    // column every block below it uses, or on desktop the headline hangs to the
    // left of the content it introduces.
    <div
      data-component="PageHeading"
      className={hasEvent ? "mx-auto max-w-xl text-left" : "text-center"}
    >
      {!hasEvent && (
        <div data-component="LeadMagnetSuccessIcon">
          <Flex
            aria-hidden="true"
            align="center"
            justify="center"
            className="mx-auto mb-3 h-12 w-12 rounded-full bg-brand/10 text-(length:--type-heading) md:mb-4 md:h-14 md:w-14 md:text-3xl"
          >
            {mode === "confirm" ? "✉️" : "🎉"}
          </Flex>
        </div>
      )}
      <Text variant="subheading" as="h1" className="text-fg">
        {title}
      </Text>
      {subtitle && (
        <Text variant="body-sm" as="p" className="mx-auto mt-2 max-w-xl text-muted">
          {subtitle}
        </Text>
      )}
    </div>
  );
}

PageHeading.displayName = "PageHeading";
